module.exports = "/templates/resetpassword.html";


//////////////////
// WEBPACK FOOTER
// ./src/templates/resetpassword.html
// module id = 457
// module chunks = 0